// extracted by mini-css-extract-plugin
module.exports = {"tertiary":"TertiaryButton--tertiary--1ygry"};